import React, { Suspense, lazy }  from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

//import { applyPolyfills, defineCustomElements } from 'spwc-io/loader';
import { Capacitor } from '@capacitor/core';

import "bootstrap/dist/css/bootstrap-grid.min.css";
import "./index.css";
import './css/App.css';

import Landing from './pages/Landing';
import TradingView from './pages/TradingView';

if (Capacitor.isNativePlatform()) {
  document.documentElement.classList.add(`native-${Capacitor.getPlatform()}`);
  document.body.classList.add(`native-${Capacitor.getPlatform()}`);
}

const BlogPost = lazy(() => import('./components/BlogPost'));
const RSI = lazy(() => import('./pages/RSI'));
const Dashboard = lazy(() => import('./pages/Dashboard'));

const routing = (
  <Router>
    <Toaster
      position="bottom-center"
      toastOptions={{
        duration: 2500,
      }}
      containerStyle={{
        bottom: 'calc(24px + env(safe-area-inset-bottom, 0px))',
      }}
    />
    <Suspense fallback={
       <div className="bg">
        <section className="mx-5">
          <div className="vh-100">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-12 text-center">
                <div className="spinner">
                    <div className="bounce1"></div>
                    <div className="bounce2"></div>
                    <div className="bounce3"></div>
                  </div>
              </div>
            </div>
          </div>
        </section>
      </div>      
      }>
      <Switch>
        <Route exact path="/stripe/success" component={Dashboard} />
        <Route exact path="/stripe/canceled" component={Dashboard} />
        {Capacitor.isNativePlatform() &&
          <Route exact path="/" component={Landing} />
        }
        {!Capacitor.isNativePlatform() &&
          <Route exact path="/" component={Landing} />
        }
        <Route exact path="/relative-strength-index/:coin" component={RSI} />
        <Route exact path="/blog/:url" component={BlogPost} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/tv/:coin" component={TradingView} />
      </Switch>
    </Suspense>
  </Router>
)

ReactDOM.render(routing, document.getElementById('root'));

if ('serviceWorker' in navigator) {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch(error => {
        console.error('Service worker registration failed:', error);
      });
    });
  } else {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });

    if ('caches' in window) {
      caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => caches.delete(cacheName));
      });
    }
  }
}

/*applyPolyfills().then(() => {
  defineCustomElements();
});*/
